import angular from 'angular';

const dependencies = ['Sq.AppConstants', 'Sq.Core'];

/**
 * The Sq.AssetGroups module contains all functionality related to asset groups
 */
export default angular.module('Sq.AssetGroups', dependencies);
